import React from 'react';
import {SpinnerIcon} from './icons';

type DataLoaderProps<T> = {
    children: (p0: T) => React.ReactNode;
    loader: () => Promise<T>;
};

export function DataLoader<T>(props: DataLoaderProps<T>) {
    const [ready, setReady] = React.useState(false);
    const [data, setData] = React.useState<T | undefined>(undefined);
    const [error, setError] = React.useState<Error | undefined>(undefined);
    const mut = React.useRef(false);

    React.useEffect(() => {
        if (!mut.current) {
            mut.current = true;
            props
                .loader()
                .then((result) => {
                    setReady(true);
                    setData(result);
                })
                .catch((err) => {
                    setError(err);
                });
        }
    });

    if (error) {
        return (
            <div className={'flex flex-col items-center justify-center'}>
                <span className={'text-xl font-semibold text-red-600'}>Error</span>
                <span className={'text-sm font-semibold text-red-600'}>{error.message}</span>
            </div>
        );
    }

    if (!ready) {
        return (
            <div className={'flex flex-col items-center justify-center'}>
                <SpinnerIcon />
                <span className={'sr-only'}>Loading...</span>
            </div>
        );
    }

    return <>{props.children(data!)}</>;
}
